module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANBAMAAACAxflPAAAAJFBMVEUGBgZMaXEAAAD///8AAADz8/Pu7u4AAAAAAACdnZ1DQ0P////vsg2fAAAADHRSTlNNADSZEoWAKkdfUpbXwKhPAAAAUElEQVQIHWMQFNHgUBEUYBAsYGBgKBRgEAJSDOwCDA6cGRyRDA4MCqxmS80YFBgaOII3ZzA0ACVXWy8AkkC+MYgPk4eph+mHmScoosAANB8ABiAOvQh/9OsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/X-editable/dist/bootstrap3-editable/img/clear.png
// module id = ./node_modules/X-editable/dist/bootstrap3-editable/img/clear.png
// module chunks = 0